import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { Payer } from '../../models/payer';
import { storeData } from '../../utils';
import {
    getPayers,
    getOtherPayers
} from '../../apis/payer';

export interface State {
    allIds: number[];
    byId: Dictionary<Payer>;
    loading: Dictionary<boolean>;
}

export const payers = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Payer[],
            loadingKey?: string
        ): State => {
            const byId = {
                ...state.byId,
                ...storeData(data, 'id')
            };
            return {
                ...state,
                allIds: Object.keys(byId)
                    .sort((a, b) => (byId[a]!.name || '') > (byId[b]!.name || '') ? 1 : -1)
                    .map(x => +x),
                byId: byId,
                ...loadingKey && {
                    loading: {
                        ...state.loading,
                        [loadingKey]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getPayersAsync(ids: Undefinable<number>[], rootState: RootState) {
            const notExistedIds = selectors.getOtherPayerIds(rootState.payers, ids);
            if (notExistedIds.length > 0) {
                try {
                    const data = await getPayers(notExistedIds);
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        },
        async getOtherPayersAsync(_: {}, rootState: RootState) {
            const existedIds = selectors.getPayerIds(rootState.payers);
            this.loading('getOtherPayersAsync', true);
            try {
                const data = await getOtherPayers(existedIds);
                this.update(data, 'getOtherPayersAsync');
            } catch (e) {
                window.console.log(e);
                this.loading('getOtherPayersAsync', false);
            }
        }
    })
});
